import { render, staticRenderFns } from "./kbsz.vue?vue&type=template&id=11e24920&scoped=true"
import script from "./kbsz.vue?vue&type=script&lang=js"
export * from "./kbsz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e24920",
  null
  
)

export default component.exports